import { defineComponent as _defineComponent } from 'vue'
interface Props {
        currentStep: number
        totalSteps: number
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'progressBar',
  props: {
    currentStep: { default: 1 },
    totalSteps: { default: 5 }
  },
  setup(__props: any) {

    

return { __sfc: true, }
}

})